import styled from "styled-components";

export const ToolbarWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ToolbarLeftSlot = styled.div`
  flex-shrink: 0;
`;

export const ToolbarCenter = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 0;
`;

export const ToolbarRightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;

  @container editor-toolbar (max-width: 650px) {
    width: 100%;
    margin-left: 0;
    margin-top: 8px;
    justify-content: flex-start;
  }
`;

export const AiSectionContainer = styled.div`
  display: ${(props) => (props.$isOpen ? "flex" : "none")};
  width: 100%;
  padding: 12px;
  background: radial-gradient(77.51% 157.3% at 18.46% 91.07%, #E5F8FF 0%, #FFFFFF 80.17%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
  border: 0.5px solid #00B5D9;
  height: 107.6px;
  margin-top: 16px;
  flex-direction: column;
  gap: 16px;
  border-radius: 8px;
`;

export const AiWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 32px;

  & > .ai-search-container {
    flex: 1;
  }

  & > .ai-search-container > div > div   {
    border-radius: 8px;
    border: 1px solid #2173FF;
  }

  & > .ai-search-container > div > div > span svg  {
    color: #2173FF;
    height: 15px;
  }

  & > .ai-actions-container {
    display: flex;
    flex: 0;
    flex-direction: row;
    gap: 8px;
  }
`;

export const TagsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 10px;
`;